import { jsx } from "react/jsx-runtime";
import {
  SimpleSelect as BaseSimpleSelect
} from "../../../../components/SimpleSelect/index.js";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
const defaultComponentValue = "";
function SimpleSelect(props) {
  const {
    options,
    clearable,
    selectProps,
    initialValue = defaultComponentValue,
    renderValue,
    renderOptions,
    inputLabelProps,
    formControlProps,
    validateOn = "change",
    ...bridgeOptions
  } = props;
  const {
    config: { fullWidth, label, name, testId = "select-root" },
    fieldInfo: {
      field: { required, visible },
      value,
      onBlur,
      onFocus,
      onChange,
      fieldDisabled,
      fieldHasError,
      showErrorAccent,
      errorOrHelperText
    }
  } = useTidalFormBridge({ ...bridgeOptions, validateOn, initialValue });
  const handleOnChange = (event) => {
    onChange(event.target.value);
  };
  const handleOnClear = () => {
    if (selectProps?.onClear) {
      selectProps?.onClear();
    } else {
      onChange("");
    }
  };
  const onClear = clearable ? handleOnClear : void 0;
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    BaseSimpleSelect,
    {
      onClear,
      ...selectProps,
      name,
      label,
      error: showErrorAccent && fieldHasError,
      value,
      onBlur,
      testId,
      onFocus,
      options,
      disabled: fieldDisabled,
      onChange: handleOnChange,
      required,
      fullWidth,
      helperText: errorOrHelperText,
      renderValue,
      renderOptions,
      "data-tidal-form-field-name": bridgeOptions.name,
      componentsProps: {
        ...selectProps?.componentsProps,
        // @ts-expect-error
        label: {
          ...inputLabelProps,
          ...selectProps?.componentsProps?.label
        },
        // @ts-expect-error
        root: {
          ...formControlProps,
          ...selectProps?.componentsProps?.root,
          "data-tidal-form-field-name": name,
          sx: {
            // formControlProps?.sx is deprecated
            ...formControlProps?.sx,
            // selectProps?.sx has less priority than selectProps?.componentsProps?.root?.sx
            ...selectProps?.sx,
            // @ts-expect-error SX is recognized when setting the props but not here, some TS voodoo is going on here
            ...selectProps?.componentsProps?.root?.sx,
            "&.tidal-form-devtool-highlight": (theme) => ({
              outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
            })
          }
        }
      }
    }
  );
}
export {
  SimpleSelect
};
//# sourceMappingURL=SimpleSelect.js.map
